import React, { Component } from "react";
import '../InitialForm/InitialFormStyleSheet.css';
import { isValidPhoneNumber, validateEmail ,validateName} from "../HWLibrary/HWUtils";
import { s360ConfigService } from "../Services/S360Config";

class ChatStartButton extends Component {

    constructor(props) {
        super(props);
        this.messageRef = React.createRef();
        this.state = {
            isHovering: false,
        };
    }
      handleRedirect = () => {
        this.props.handleRedirect();
      };

    render() {
        return (
            <button onClick={this.handleRedirect}
             class="s360-initial-channel-start-btn" target="_blank" rel="noopener noreferrer" style={this.buttonStyle()}>
                {/* <div>
                    <img src={this.props.item.icon} width="16" height="17"></img>
                </div> */}
                {this.props.item.label}
            </button>
        );
    }

    buttonStyle = () => {
        return {
            background: this.props.item.background,
            color:      this.props.item.color
        }
    }

    formInputBoxContainerStyle = () => {
        return {
            color: s360ConfigService.config.designDetails.headerColor,
        }
    }

    formInputBoxStyle = () => {
        return {
            borderColor: s360ConfigService.config.designDetails.headerColor,
            color: s360ConfigService.config.designDetails.headerColor,
            backgroundColor:s360ConfigService.config.designDetails.pageBackgroundColor 
        }
    }

    onClickInput = (e) => {
        if (e.target.value === this.props.item.label) {
            e.target.style.color='rgb(0,0,0)';
            this.messageRef.current.value = "";
        }
    }

    onInputOut = (e) => {
        if (!e.target.value || !e.target.value.trim) {
            e.target.style.color='inherit';
            this.messageRef.current.value = this.props.item.label;
        }
    };

    value = () => { 
        if ((!this.messageRef.current.value || !this.messageRef.current.value.trim()) || (this.messageRef.current.value.trim() === this.props.item.label)) {
            return {}
        }
        let aValue = {};
        aValue[this.props.item.label] = this.messageRef.current.value; 
        return aValue;
    };

    validate = () => { 
        let formItemDetails = this.props.item || {};
        let isRequired = formItemDetails.required || formItemDetails.primaryField;
        let isValidationEnabled = formItemDetails.validate !== "None";
        if ((!this.messageRef.current.value || !this.messageRef.current.value.trim()) || (this.messageRef.current.value.trim() === this.props.item.label)) {
            return isRequired || isValidationEnabled ? false: true;
        }
        if (isValidationEnabled) {
            if (formItemDetails.validate.toLowerCase() === "phone") {
                return isValidPhoneNumber(this.messageRef.current.value);
             } else if (formItemDetails.validate.toLowerCase() === "email") {
                 return validateEmail(this.messageRef.current.value);
             } else if(formItemDetails.validate.toLowerCase() === "name"){
                return validateName(this.messageRef.current.value);
             }
        }
        return true;
    }

    validationErrorMessage = () => {
        return "Please enter a valid " + this.props.item.label.toLowerCase() + ".";
    }

}

export default ChatStartButton;